import { useEffect } from "react";

import { useState } from "react";

// Detect if page is in iframe
const useInIframe = () => {
  const [isInIframe, setIsInIframe] = useState(false);

  useEffect(() => {
    try {
      setIsInIframe(window.self !== window.top);
    } catch (e) {
      // If we can't access window.top due to security restrictions,
      // we're definitely in a cross-origin iframe
      setIsInIframe(true);
    }
  }, []);

  return isInIframe;
};

export default useInIframe;
